/* eslint-disable no-console */
import { Component, ElementRef, ViewChild } from "@angular/core";
@Component({
  selector: "gh-example-tag-component",
  templateUrl: "./example-tag.component.html",
  styleUrls: ["./example-tag.component.less"],
})
export class ExampleTagComponent {
  public tags = ["Can't remove", "Pencho", "omg"];
  public inputVisible = false;
  public inputValue = "";
  @ViewChild("inputElement", { static: false }) public inputElement?: ElementRef;

  public sliceTagName(tag: string): string {
    const isLongTag = tag.length > 20;
    return isLongTag ? `${tag.slice(0, 20)}...` : tag;
  }

  public handleClose(removedTag: string): void {
    this.tags = this.tags.filter((tag) => tag !== removedTag);
  }

  public showInput(): void {
    this.inputVisible = true;
    setTimeout(() => {
      this.inputElement?.nativeElement.focus();
    }, 10);
  }

  public handleInputConfirm(): void {
    if (this.inputValue && this.tags.indexOf(this.inputValue) === -1) {
      this.tags = [...this.tags, this.inputValue];
    }
    this.inputValue = "";
    this.inputVisible = false;
  }

  public checkChange(checked): void {
    console.log(checked);
  }
}
